export default __webpack_public_path__ + "images/15dd4a3a546c59369ec4dd2fb092c4fe-5_tablet_1067x470.jpg";